import type { AdminFlowRun } from "../models/admin-flows.models";
import { getAdminFlowRun } from "../services/admin-flows.service";
import { getAdminAgentErrorMessage } from "../utils/admin-agent.utils";
import { useEffect, useState } from "react";

// Read the selected immutable snapshot separately from lightweight history polling.
export const useAdminFlowReview = (token: string | undefined, id: string | undefined) => {
  const [run, setRun] = useState<AdminFlowRun>();
  const [error, setError] = useState("");
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    let timer: ReturnType<typeof setTimeout>;
    setRun(undefined);
    setError("");

    if (!id) return;

    const read = async () => {
      try {
        const snapshot = await getAdminFlowRun(token, id, controller.signal);

        if (!controller.signal.aborted) {
          setRun(snapshot);

          if (snapshot.status === "running") timer = setTimeout(read, 1500);
        }
      } catch (reason) {
        if (!controller.signal.aborted) {
          setRun(undefined);
          setError(getAdminAgentErrorMessage(reason));
        }
      }
    };
    void read();

    return () => {
      controller.abort();
      clearTimeout(timer);
    };
  }, [token, id, refresh]);

  return { run: run?.id === id ? run : undefined, error, reload: () => setRefresh((value) => value + 1) };
};
